import { lazy } from 'react';

export const GenericNotFound = lazy(() =>
  import('../components/GenericNotFound/GenericNotFound').then((module) => ({
    default: module.GenericNotFound
  }))
);

export const Login = lazy(() =>
  import('../components/Auth/Login').then((module) => ({ default: module.default }))
);
